import { render, staticRenderFns } from "./SelectionTemplate.vue?vue&type=template&id=dfe67d9a&scoped=true"
import script from "./SelectionTemplate.vue?vue&type=script&lang=js"
export * from "./SelectionTemplate.vue?vue&type=script&lang=js"
import style0 from "./SelectionTemplate.vue?vue&type=style&index=0&id=dfe67d9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe67d9a",
  null
  
)

export default component.exports